import React, { useRef } from 'react';
import styled from 'styled-components';
import { inputFocusHandler } from 'utils/focusHandler';

const TitleInput = styled.input`
  display: flex;
  padding: 12px;
  width: 100%;

  border-radius: 8px;
  border: 1px solid #dbdcdf;
  background: #fff;

  color: #1b1c1e;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.6px;

  &::placeholder {
    color: #c2c4c8;
  }
`;

const TimeInput = styled.input`
  display: flex;
  width: 70px;
  border: none;

  color: #1b1c1e;
  text-align: right;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.6px;

  &::placeholder {
    color: #c2c4c8;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  inputType: 'title' | 'time';
}

const CurriculumInput = (props: Props) => {
  const { inputType, ...rest } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  if (inputType === 'title') {
    return (
      <TitleInput
        ref={inputRef}
        onFocus={() => inputFocusHandler(inputRef)}
        {...rest}
      />
    );
  }

  return (
    <TimeInput
      ref={inputRef}
      onFocus={() => inputFocusHandler(inputRef)}
      {...rest}
    />
  );
};

export default CurriculumInput;
